/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./row.component";
var styles_RowComponent = [];
var RenderType_RowComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_RowComponent, data: {} });
export { RenderType_RowComponent as RenderType_RowComponent };
export function View_RowComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵted(-1, null, ["\n        "])), i0.ɵncd(null, 0), (_l()(), i0.ɵted(-1, null, ["\n    "]))], null, null); }
export function View_RowComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ig-row", [], [[8, "className", 0]], null, null, View_RowComponent_0, RenderType_RowComponent)), i0.ɵdid(1, 638976, null, 0, i1.RowComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, function (_ck, _v) { var currVal_0 = i0.ɵnov(_v, 1).className; _ck(_v, 0, 0, currVal_0); }); }
var RowComponentNgFactory = i0.ɵccf("ig-row", i1.RowComponent, View_RowComponent_Host_0, { class: "class", distribution: "distribution", reverse: "reverse", pinLeft: "pinLeft", pinCenter: "pinCenter", pinRight: "pinRight", alignTop: "alignTop", alignMiddle: "alignMiddle", alignBottom: "alignBottom" }, {}, ["*"]);
export { RowComponentNgFactory as RowComponentNgFactory };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/grid/row/row.component.ngfactory.js.pre-build-optimizer.js